<template>
  <div id="register-type-layer">
    <header>
      <a href="https://www.yuanquanyun.com.cn/"><img src="../../assets/images/login/logo.png" class="logo" alt="">
</a>
      <span class="logo-text">电子合同服务平台</span>
      <span class="logo-s-title">用户注册</span>
      <router-link to="/login" class="back-prev"> <返回 </router-link>
    </header> 
    <img src="../../assets/images/register/register-type-bg.png" class="bg-img" alt="">
    <div class="register-type-content">
      <div class="type-btns">
        <el-button type="primary" @click="toUKeyRegister">Ukey用户注册</el-button>
        <el-button type="primary" @click="toUserRegister">普通用户注册</el-button>
      </div>
      <div class="type-text">
        <p class="tip1">提示：Ukey用户注册您需要 <a href="javascript:;" @click="toDownload">下载</a> 并安装驱动程序 </p>
        <p class="tip2">当前Ukey用户支持以下Ukey证书</p>
        <div class="ca-list">
          <div class="ca-item">
            <img src="../../assets/images/register/nmgca.jpg" alt="">
          </div>
          <div class="ca-item">
            <img src="../../assets/images/register/sxca.png" alt="">
          </div>
          <div class="ca-item">
            <img src="../../assets/images/register/axca.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <e-footer></e-footer>
  </div>
</template>
<script>
  import { getRandomApi } from '@/api/common'
  import { JITHTTPCLIENT } from "../../utils/JITHTTPCLIENT"
  import eFooter from '@/components/eFooter'
  export default {
    data() {
      return {
        random: '',
        randomId: ''
      }
    },
    components: {
      eFooter
    },
    methods: {
      toUserRegister() {
        this.$router.push({
          path: '/register'
        })
      },
      toUKeyRegister() {
        getRandomApi().then(res => {
          if (res.code !== 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: 'warning'
            });
          } else {
            this.random = res.data.random
            this.randomId = res.data.id
            this.detachSignHandle(this.random)
          }
        }).catch(err => {
          console.log(err)
        })
      },
      detachSignHandle(random) {
        if (!!window.ActiveXObject || "ActiveXObject" in window) { // ie
          detachSignIe(this);
        } else { // 非ie
          detachSign(this);
        }

        //非ie
        function detachSign(_this) {
          var initParam = "<?xml version=\\\"1.0\\\" encoding=\\\"utf-8\\\"?>" +
            "<authinfo><liblist>" +
            "<lib type=\\\"CSP\\\" version=\\\"1.0\\\" dllname=\\\"\\\" ><algid val=\\\"SHA1\\\" sm2_hashalg=\\\"sm3\\\"/></lib>" +
            "<lib type=\\\"SKF\\\" version=\\\"1.1\\\" dllname=\\\"R0FLRVlfU0tGLmRsbA==\\\" ><algid val=\\\"SHA1\\\" sm2_hashalg=\\\"sm3\\\"/></lib>" +
            "<lib type=\\\"SKF\\\" version=\\\"1.1\\\" dllname=\\\"bXRva2VuX2dtMzAwMF9KSVQuZGxs\\\" ><algid val=\\\"SHA1\\\" sm2_hashalg=\\\"sm3\\\"/></lib>" +
            "<lib type=\\\"SKF\\\" version=\\\"1.1\\\" dllname=\\\"SERfR01DQUlTLmRsbA==\\\" ><algid val=\\\"SHA1\\\" sm2_hashalg=\\\"sm3\\\"/></lib>" +
            "<lib type=\\\"SKF\\\" version=\\\"1.1\\\" dllname=\\\"U2h1dHRsZUNzcDExXzMwMDBHTS5kbGw=\\\" ><algid val=\\\"SHA1\\\" sm2_hashalg=\\\"sm3\\\"/></lib>" +
            "<lib type=\\\"SKF\\\" version=\\\"1.1\\\" dllname=\\\"SklUR01LRVlfU0pLMTQyNC5kbGw=\\\" ><algid val=\\\"SHA1\\\" sm2_hashalg=\\\"sm3\\\"/></lib>" +
            "<lib type=\\\"SKF\\\" version=\\\"1.1\\\" dllname=\\\"U0tGQVBJLmRsbA==\\\" ><algid val=\\\"SHA1\\\" sm2_hashalg=\\\"sm3\\\"/></lib>" +
            "<lib type=\\\"SKF\\\" version=\\\"1.1\\\" dllname=\\\"QU5YSU5Dc3AxMV8zMDAwR01BLmRsbA==\\\" ><algid val=\\\"SHA1\\\" sm2_hashalg=\\\"sm3\\\"/></lib>" +
            "<lib type=\\\"SKF\\\" version=\\\"1.1\\\" dllname=\\\"QU5YSU5Dc3AxMV8zMDAwR00uZGxs\\\" ><algid val=\\\"SHA1\\\" sm2_hashalg=\\\"sm3\\\"/></lib>" +
            "<lib type=\\\"SKF\\\" version=\\\"1.1\\\" dllname=\\\"bXRva2VuX2dtMzAwMF9wY3NjLmRsbA==\\\" ><algid val=\\\"SHA1\\\" sm2_hashalg=\\\"sm3\\\"/></lib>" +
            "<lib type=\\\"SKF\\\" version=\\\"1.1\\\" dllname=\\\"U0tGQVBJMjA1NDkuZGxsIA====\\\" ><algid val=\\\"SHA1\\\" sm2_hashalg=\\\"sm3\\\"/></lib>" +
            "<lib type=\\\"SKF\\\" version=\\\"1.1\\\" dllname=\\\"U21hcnRDVENBUEkuZGxs\\\" ><algid val=\\\"SHA1\\\" sm2_hashalg=\\\"sm3\\\"/></lib>" +
            "<lib type=\\\"SKF\\\" version=\\\"1.1\\\" dllname=\\\"bXRva2VuX2dtMzAwMC5kbGw=\\\" ><algid val=\\\"SHA1\\\" sm2_hashalg=\\\"sm3\\\"/></lib>" +
            "<lib type=\\\"SKF\\\" version=\\\"1.1\\\" dllname=\\\"U0tGQVBJMjAwNzkuZGxs\\\" ><algid val=\\\"SHA1\\\" sm2_hashalg=\\\"sm3\\\"/></lib>" +
            "<lib type=\\\"SKF\\\" version=\\\"1.1\\\" dllname=\\\"U21hcnRDVENBUElISUQuZGxs\\\" ><algid val=\\\"SHA1\\\" sm2_hashalg=\\\"sm3\\\"/></lib>" +
            "<lib type=\\\"SKF\\\" version=\\\"1.1\\\" dllname=\\\"RlJJRHJpdmVyU0tGMi5kbGw=\\\" ><algid val=\\\"SHA1\\\" sm2_hashalg=\\\"sm3\\\"/></lib>" +
            "<lib type=\\\"SKF\\\" version=\\\"1.1\\\" dllname=\\\"U3hjYUNzcDExXzMwMDBHTS5kbGw=\\\" ><algid val=\\\"SHA1\\\" sm2_hashalg=\\\"sm3\\\"/></lib>" +
            "<lib type=\\\"SKF\\\" version=\\\"1.1\\\" dllname=\\\"Q0ZDQV9VS0VZX0dNQVBJLmRsbA==\\\" ><algid val=\\\"SHA1\\\" sm2_hashalg=\\\"sm3\\\"/></lib>" +
            "</liblist></authinfo>";
          var ret = -1;
          var message = "";
          if (random) {
            ret = JITHTTPCLIENT.RegisterParam(initParam);
            if (ret != 0) {
              if (ret == 100) {
                alert("数据格式错误");
              } else if (ret == 500) {
                alert("业务处理中");
              } else {
                ret = JITHTTPCLIENT.GetErrorCode();
                if (ret != 0) {
                  message = JITHTTPCLIENT.GetErrorMessage(ret);
                  alert("初始化失败,错误码" + ret + " 错误信息" + message);
                }
              }
              return;
            }
            //
            ret = JITHTTPCLIENT.SetCertChooseType(0);
            if (ret != 0) {
              ret = JITHTTPCLIENT.GetErrorCode();
              if (ret != 0) {
                message = JITHTTPCLIENT.GetErrorMessage(ret);
                alert("设置证书选择类型失败,错误码" + ret + " 错误信息" + message);
              }
              return;
            }
            //
            ret = JITHTTPCLIENT.SetCert("SC", "", "", "", "", "");
            if (ret != 0) {
              ret = JITHTTPCLIENT.GetErrorCode();
              if (ret != 0) {
                message = JITHTTPCLIENT.GetErrorMessage(ret);
                alert("设置证书过滤失败,错误码" + ret + " 错误信息" + message);
              }
              return;
            }

            //	
            message = JITHTTPCLIENT.DetachSignStr("", random);
            ret = JITHTTPCLIENT.GetErrorCode();
            if (ret != 0) {
              message = JITHTTPCLIENT.GetErrorMessage(ret);
              alert("签名失败,错误码" + ret + "错误信息" + message);
            } else { // 签名成功
              _this.toRegisterHandle(message)
            }
            return;
          } else {
            alert("输入项为空");
          }
        }

        function detachSignIe(_this) {
          var InitParam = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\
            <authinfo><liblist>\
            <lib type=\"CSP\" version=\"1.0\" dllname=\"\" ><algid val=\"SHA1\" sm2_hashalg=\"sm3\"/></lib>\
            <lib type=\"SKF\" version=\"1.1\" dllname=\"R0FLRVlfU0tGLmRsbA==\" ><algid val=\"SHA1\" sm2_hashalg=\"sm3\"/></lib>\
            <lib type=\"SKF\" version=\"1.1\" dllname=\"bXRva2VuX2dtMzAwMF9KSVQuZGxs\" ><algid val=\"SHA1\" sm2_hashalg=\"sm3\"/></lib>\
            <lib type=\"SKF\" version=\"1.1\" dllname=\"SERfR01DQUlTLmRsbA==\" ><algid val=\"SHA1\" sm2_hashalg=\"sm3\"/></lib>\
            <lib type=\"SKF\" version=\"1.1\" dllname=\"U2h1dHRsZUNzcDExXzMwMDBHTS5kbGw=\" ><algid val=\"SHA1\" sm2_hashalg=\"sm3\"/></lib>\
            <lib type=\"SKF\" version=\"1.1\" dllname=\"SklUR01LRVlfU0pLMTQyNC5kbGw=\" ><algid val=\"SHA1\" sm2_hashalg=\"sm3\"/></lib>\
            <lib type=\"SKF\" version=\"1.1\" dllname=\"U0tGQVBJLmRsbA==\" ><algid val=\"SHA1\" sm2_hashalg=\"sm3\"/></lib>\
            <lib type=\"SKF\" version=\"1.1\" dllname=\"QU5YSU5Dc3AxMV8zMDAwR01BLmRsbA==\" ><algid val=\"SHA1\" sm2_hashalg=\"sm3\"/></lib>\
            <lib type=\"SKF\" version=\"1.1\" dllname=\"QU5YSU5Dc3AxMV8zMDAwR00uZGxs\" ><algid val=\"SHA1\" sm2_hashalg=\"sm3\"/></lib>\
            <lib type=\"SKF\" version=\"1.1\" dllname=\"bXRva2VuX2dtMzAwMF9wY3NjLmRsbA==\" ><algid val=\"SHA1\" sm2_hashalg=\"sm3\"/></lib>\
            <lib type=\"SKF\" version=\"1.1\" dllname=\"U0tGQVBJMjA1NDkuZGxsIA====\" ><algid val=\"SHA1\" sm2_hashalg=\"sm3\"/></lib> \
            <lib type=\"SKF\" version=\"1.1\" dllname=\"U21hcnRDVENBUEkuZGxs\" ><algid val=\"SHA1\" sm2_hashalg=\"sm3\"/></lib>\
            <lib type=\"SKF\" version=\"1.0\" dllname=\"bXRva2VuX2dtMzAwMC5kbGw=\"><algid val=\"SHA1\" sm2_hashalg=\"SM3\" /></lib>\
            <lib type=\"SKF\" version=\"1.1\" dllname=\"U0tGQVBJMjAwNzkuZGxs\" ><algid val=\"SHA1\" sm2_hashalg=\"sm3\"/></lib>\
            <lib type=\"SKF\" version=\"1.1\" dllname=\"U21hcnRDVENBUElISUQuZGxs\" ><algid val=\"SHA1\" sm2_hashalg=\"sm3\"/></lib>\
            <lib type=\"SKF\" version=\"1.1\" dllname=\"RlJJRHJpdmVyU0tGMi5kbGw=\" ><algid val=\"SHA1\" sm2_hashalg=\"sm3\"/></lib>\
            <lib type=\"SKF\" version=\"1.1\" dllname=\"U3hjYUNzcDExXzMwMDBHTS5kbGw=\" ><algid val=\"SHA1\" sm2_hashalg=\"sm3\"/></lib>\
            <lib type=\"SKF\" version=\"1.1\" dllname=\"Q0ZDQV9VS0VZX0dNQVBJLmRsbA==\" ><algid val=\"SHA1\" sm2_hashalg=\"sm3\"/></lib>\
            </liblist></authinfo>";
          var ret = 1;
          if (random) {
            JITComVCTKEx.Initialize(InitParam);
            if (JITComVCTKEx.GetErrorCode() != 0) {
              alert("初始化失败,错误码" + JITComVCTKEx.GetErrorCode() + " 错误信息" + JITComVCTKEx.GetErrorMessage(JITComVCTKEx
                .GetErrorCode()));
              return;
            }

            JITComVCTKEx.SetCertChooseType(1);
            if (JITComVCTKEx.GetErrorCode() != 0) {

              alert("错误码" + JITComVCTKEx.GetErrorCode() + "错误信息" + JITComVCTKEx.GetErrorMessage(JITComVCTKEx
                .GetErrorCode()));
              JITComVCTKEx.Finalize();
              return;
            }

            JITComVCTKEx.SetCert("SC", "", "", "", "", "");
            if (JITComVCTKEx.GetErrorCode() != 0) {
              alert("设置证书过滤失败,错误码" + JITComVCTKEx.GetErrorCode() + " 错误信息" + JITComVCTKEx.GetErrorMessage(JITComVCTKEx
                .GetErrorCode()));
              JITComVCTKEx.Finalize();
              return;
            }

            var sign = JITComVCTKEx.DetachSignStr("", random);
            _this.toRegisterHandle(sign)

            if (JITComVCTKEx.GetErrorCode() != 0) {

              alert("错误码" + JITComVCTKEx.GetErrorCode() + "错误信息" + JITComVCTKEx.GetErrorMessage(JITComVCTKEx
                .GetErrorCode()));
              JITComVCTKEx.Finalize();
              return;
            }
            JITComVCTKEx.Finalize();
          } else {
            alert("输入项为空");
          }
        }
      },
      toRegisterHandle(sign) {
        this.$router.push({
          path: '/register',
          query: {
            rId: this.randomId,
            rcontent: sign
          }
        })
      },
      toDownload() {
        var local = window.location.hostname
        console.log(local === '123.56.76.13')
        if (local === '123.56.76.13') {
          window.location.href = 'http://123.56.76.13:8089/step.html'
        } else {
          window.location.href = 'https://vip.yuanquanyun.com.cn:31082/step.html'
        }
      }
    }
  }
</script>
<style scope>
  #register-type-layer {
    height: 100vh;
    position: relative;
    width: 100%;
    overflow: hidden;
  }

  header {
    width: 1920px;
    height: 71px;
    background: rgba(35, 43, 58, 1);
    box-shadow: 0px 2px 10px 0px rgba(4, 0, 0, 0.19);
    line-height: 71px;
    overflow: hidden;
  }

  .logo {
    margin-top: 16px;
    margin-left: 37px;
    width: 111px;
    float: left;
  }

  .logo-text {
    margin-left: 31px;
    font-size: 24px;
    color: #ffffff;
  }

  .logo-s-title {
    font-size: 24px;
    color: #ffffff;
    margin-left: 24px;
  }

  .back-prev {
    display: block;
    position: absolute;
    right: 56px;
    top: 0;
    font-size: 24px;
    color: #ffffff;
    line-height: 71px;
  }

  .bg-img {
    display: block;
    width: 324px;
    position: absolute;
    bottom: 110px;
    left: 50%;
    margin-left: -162px;
  }

  .register-type-content {
    width: 463px;
    margin: 144px auto 0;
    background: #ffffff;
    position: relative;
    z-index: 9;
    padding-bottom: 20px;
  }

  .type-btns {
    width: 463px;
    display: flex;
    justify-content: space-between;
  }

  .type-btns button {
    width: 224px;
    height: 50px;
    font-size: 18px;
  }

  .type-text {
    width: 436px;
  }

  .tip1 {
    font-size: 16px;
    color: #333333;
    margin-top: 55px;
  }

  .tip1 span {
    color: #2776FF;
  }

  .tip2 {
    font-size: 16px;
    color: #D75B58;
    margin-top: 22px;
  }

  .ca-list {
    margin-top: 16px;
    width: 400px;
    display: flex;
    justify-content: space-between;
  }

  .ca-item {
    display: block;
    width: 127px;
    height: 35px;
    border: 1px solid rgba(238, 238, 238, 1);
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ca-item img {
    display: block;
    max-width: 120px;
    max-height: 30px;
  }
</style>